<div class="m-4">
    <div class="row">
      <div class="col-7">
        <p class="titleFont">{{ title }}</p>
      </div>
      <div class="col-5 text-right">
        <div>
          <custom-button
            class="addButton"
            label="{{ 'processClaims.decisionAndSettlement.add' | translate }}"
            mode="secondary"
            [iconSrc]="addIcon"
            (onClick)="onAddNote()"
            iconPosition="after"
          >
          </custom-button>
        </div>
      </div>
    </div>
    <div class="card px-3 py-4">
      <div class="row mb-2" *ngFor="let note of notes; let i = index">
        <div class="col-10">
          <dxc-textarea
            (onChange)="onChange($event, i)"
            [value]="note.summary.freeText"
            (onBlur)="onDataBlur(note, i)"
            [disabled]="!note.summary.isEdit"
          >
          </dxc-textarea>
        </div>
        <div class="d-flex col-2 Image">
          <img class="mx-2" src="{{ editIcon }}" alt="" 
          (click)="onEditNote(i)"
          />
          <img
            class="mx-2"
            src="{{ deleteIcon }}"
            alt=""
            (click)="onDeleteConfirmation(note)"
          />
        </div>
      </div>
    </div>
    <div class="row endButtons">
      <custom-button
        class="saveBtn"
        label="{{ 'processClaims.decisionAndSettlement.save' | translate }}"
        mode="primary"
        margin="xsmall"
        (onClick)="onCloseDialog()"
      >
      </custom-button>
      <custom-button
        class="cancelBtn"
        label="{{ 'processClaims.decisionAndSettlement.cancel' | translate }}"
        mode="secondary"
        margin="xsmall"
        (onClick)="onCloseDialog()"
      >
      </custom-button>
    </div>
  </div>
  
  <!-- Confirmation Dialog box for Deleting Investigation Subtask. -->
  <dxc-dialog
    class="dialog-content"
    *ngIf="isDeleteConfirmation"
    [isCloseVisible]="false"
  >
    <div class="row justify-content-center deleteMessage">
      <p class="mt-2">
        {{ "processClaims.assessment.popUp.delete" | translate }}
      </p>
    </div>
    <div class="deleteContent">
      <p class="justify-content-center">
        {{ "processClaims.assessment.popUp.deleteClaimNote" | translate }}
      </p>
      <div class="row justify-content-center">
        <custom-button
          mode="primary"
          label="{{ 'processClaims.assessment.popUp.continue' | translate }}"
          margin="xxsmall"
          (onClick)="onDeleteNote()"
        >
        </custom-button>
  
        <custom-button
          mode="secondary"
          label="{{ 'processClaims.assessment.popUp.cancel' | translate }}"
          margin="xxsmall"
          (onClick)="onClosePopup()"
        >
        </custom-button>
      </div>
    </div>
  </dxc-dialog>
  